import React from 'react';
import { Grid, Typography } from '@mui/material';
import parse from 'html-react-parser';
import { normalizeHtmlText } from '@shared/helpers/text/normalizeHtmlText';
import { isHtml } from '@shared/helpers/text/isHtml';

const renderValue = value => {
  if (value === null || value === undefined) return [];

  if (Array.isArray(value)) {
    return value.flatMap(renderValue);
  }

  if (typeof value !== 'string') {
    return [String(value)];
  }

  return [normalizeHtmlText(value)];
};

const SubListAddRemove = ({
  modified,
  title,
  color = 'black',
  padding = '0px 16px',
  fontSize = 14,
}) => {
  if (!modified) return null;

  const values = renderValue(modified);

  return (
    <>
      <Typography style={{ fontSize: 15, padding: '0 5px' }}>
        {title}
      </Typography>

      <Grid style={{ padding: 0, margin: 0, lineHeight: 1.5 }}>
        {values.map((v, i) => {
          const isHtmlContent = isHtml(v);

          return (
            <Typography
              key={`value-${v}-${i}`}
              style={{
                color,
                fontSize,
                padding,
                lineHeight: 1.5,
                whiteSpace: 'pre-wrap',
              }}
            >
              {isHtmlContent ? parse(v) : v}
            </Typography>
          );
        })}
      </Grid>
    </>
  );
};

export default SubListAddRemove;
